// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

export function lerp(start, end, factor) {
    return start + (end - start) * factor;
}

export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

export function distance(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
}

export function easeOutElastic(t) {
    if (t === 0 || t === 1) return t;
    return Math.pow(2, -10 * t) * Math.sin((t - 0.075) * (2 * Math.PI) / 0.3) + 1;
}
